import * as Yup from 'yup';
import formModel from './formModel';

const { name, email, company } = formModel;

const validationSchema = Yup.object().shape({
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),
    [email.name]: Yup.string()
        .email('Incorrect email format')
        .required(`${email.requiredErrorMsg}`),
    [company.name]: Yup.string().required(`${company.requiredErrorMsg}`),
});

export default validationSchema;
